// extracted by mini-css-extract-plugin
module.exports = {"component":"ClubBadge_component__32iUX","logo":"ClubBadge_logo__1FPo_","clubName":"ClubBadge_clubName__3F3yo","clubLocation":"ClubBadge_clubLocation__Vmn1M"};